















































































































/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue } from 'vue-property-decorator';
import LayoutContent from '@/components/LayoutContent.vue';
import TagInput from '@/components/TagInput.vue';
import FormInput from '@/components/FormInput.vue';
import Loader from '@/components/Loader.vue';
import Header from '@/components/Table/Header.vue';
import api, { apiProduction, apiSandbox } from '@/libs/api';
import { MerchantsAdds } from '@/libs/api.interfaces';
// eslint-disable-next-line import/no-cycle
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import ToggleSelect from '@/components/ToggleSelect.vue';
import Button from '@/components/Button.vue';

@Component({
  components: {
    LayoutContent,
    Loader,
    TagInput,
    Header,
    FormInput,
    ToggleSelect,
    Button,
  },
  // methods: {
  //   numberFormat,
  // },
})
export default class PricingDetail extends Vue {
  loading = false;
  loadingSubmit = false;
  isSetting = false;
  isProduction = false;

  // toggleStatus = ['Rupiah', 'Percent'];
  toggleTypeSharing = true;
  typeSharing = true;
  typeSharingText = 'Percent (%)';
  typeRevenue = 'MDR';
  merchantSharing = '';
  companySharing = '';

  addsMerchant!: MerchantsAdds;

  async created() {
    await this.getAddsMerchant();
  }

  // eslint-disable-next-line class-methods-use-this
  async toggleTypeSharingClick(value: boolean) {
    this.typeSharing = value;
    // eslint-disable-next-line no-empty
    if (value === false) {
      this.typeRevenue = 'FIX';
      this.typeSharingText = 'Nominal (Rp)';
      if (this.addsMerchant) {
        if (this.addsMerchant.type_revenue === 'FIX') {
          // eslint-disable-next-line max-len
          this.merchantSharing = this.addsMerchant.revenue_merchant_sharing !== null ? this.addsMerchant.revenue_merchant_sharing : '';
          // eslint-disable-next-line max-len
          this.companySharing = this.addsMerchant.revenue_company_sharing !== null ? this.addsMerchant.revenue_company_sharing : '';
        } else {
          this.merchantSharing = '';
          this.companySharing = '';
        }
      } else {
        this.merchantSharing = '';
        this.companySharing = '';
      }
    // eslint-disable-next-line no-empty
    } else if (value === true) {
      this.typeRevenue = 'MDR';
      this.typeSharingText = 'Percent (%)';
      if (this.addsMerchant) {
        if (this.addsMerchant.type_revenue === 'MDR') {
          // eslint-disable-next-line max-len
          this.merchantSharing = this.addsMerchant.revenue_merchant_sharing !== null ? this.addsMerchant.revenue_merchant_sharing : '';
          // eslint-disable-next-line max-len
          this.companySharing = this.addsMerchant.revenue_company_sharing !== null ? this.addsMerchant.revenue_company_sharing : '';
        } else {
          this.merchantSharing = '';
          this.companySharing = '';
        }
      } else {
        this.merchantSharing = '';
        this.companySharing = '';
      }
    }
  }

  // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-empty-function
  async getAddsMerchant() {
    const id = this.$route.params.type;
    try {
      this.loading = true;
      const { data } = await api.get(`/res/adds-reseller-main/${id}`);
      this.addsMerchant = data;
      this.toggleTypeSharing = data.type_revenue === 'FIX';
      // eslint-disable-next-line no-unneeded-ternary
      if (data.type_revenue === 'FIX') {
        this.typeRevenue = 'FIX';
        this.typeSharing = true;
        await this.toggleTypeSharingClick(false);
        // eslint-disable-next-line max-len
        this.merchantSharing = this.addsMerchant.revenue_merchant_sharing !== null ? this.addsMerchant.revenue_merchant_sharing : '';
        // eslint-disable-next-line max-len
        this.companySharing = this.addsMerchant.revenue_company_sharing !== null ? this.addsMerchant.revenue_company_sharing : '';
      } else if (data.type_revenue === 'MDR') {
        this.typeRevenue = 'MDR';
        this.typeSharing = true;
        await this.toggleTypeSharingClick(true);
        // eslint-disable-next-line max-len
        this.merchantSharing = this.addsMerchant.revenue_merchant_sharing !== null ? this.addsMerchant.revenue_merchant_sharing : '';
        // eslint-disable-next-line max-len
        this.companySharing = this.addsMerchant.revenue_company_sharing !== null ? this.addsMerchant.revenue_company_sharing : '';
      }
      this.loading = false;
    } catch (err) {
      this.loading = false;
      // showToast(
      //   ToastType.FAILED,
      //   'Error',
      //   'Failed to get additional detail',
      // );
    }
  }

  // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-empty-function
  async submitAddsMerchant() {
    const id = this.$route.params.type;
    this.loading = false;
    this.loadingSubmit = true;
    try {
      if (this.addsMerchant) {
        const { data } = await api.put(`/res/adds-reseller-main/revenue/${id}`, {
          type_revenue: this.typeRevenue,
          revenue_merchant_sharing: this.merchantSharing,
          revenue_company_sharing: this.companySharing,
        });
        showToast(ToastType.SUCCESS, data.case, data.message);
      } else {
        const { data } = await api.post(`/res/adds-reseller-main/revenue/${id}`, {
          type_revenue: this.typeRevenue,
          revenue_merchant_sharing: this.merchantSharing,
          revenue_company_sharing: this.companySharing,
        });
        showToast(ToastType.SUCCESS, data.case, data.message);
      }
    } catch (err) {
      showToast(ToastType.FAILED, 'Oops… Sorry', (err as any).response.data.error.errors.map((e: any) => e.message));
      this.loading = false;
    }
    this.loadingSubmit = false;
    this.getAddsMerchant();
  }
}
